import React from 'react';
import PropTypes from 'prop-types';

import Parser from 'html-react-parser';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

class BlogArticleList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {input} = this.props

        if(!(input && Array.isArray(input.items)))
            return null

        return (
            <section>
                {input.primary.title_of_section.html ? (
                    <header>
                        {Parser(input.primary.title_of_section.html)}
                    </header>
                ) : ''}
                <div className="content articleList">
                    <ul className="alt">
                        {input.items.map(({articles_to_link:articleItem}, i) => {
                            if(articleItem.link_type === 'Web')
                               return (
                                <div key={i} className="articleCard">
                                <div className="postDetail">
                                    <a href={articleItem.url} target="_blank">{articleItem.url}</a>
                                </div>
                                </div>
                               )
                            else
                                return (
                                    <div key={i} className="articleCard">
                                        <div className="postImage">
                                            {articleItem.document[0].data.image.localFile != null ? (
                                                <Link to={`/blog/${articleItem.slug}`}><Img fluid={articleItem.document[0].data.image.localFile.childImageSharp.fluid}/></Link>
                                            ) : ''}
                                        </div>
                                        <div className="postDetail">
                                            <span className="datePost">{articleItem.document[0].data.publishdate}</span>
                                            <h3><Link to={`/blog/${articleItem.slug}`}>
                                                {articleItem.document[0].data.title.text}
                                            </Link></h3>
                                            <Link to={`/blog/${articleItem.slug}`}>
                                                {Parser(articleItem.document[0].data.subtitle.html)}
                                            </Link>
                                        </div>
                                    </div>
                                )
                        })}
                    </ul>
                </div>
            </section>
        )
    }
}
BlogArticleList.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogArticleList;